__webpack_require__.p = "https://cdn-activity.mini1.cn/game-share/";